package dev.terrakok.mapitan.domain.geojson

import dev.terrakok.mapitan.domain.Document
import dev.terrakok.mapitan.domain.DocumentObject
import dev.terrakok.mapitan.domain.Label
import dev.terrakok.mapitan.domain.utils.toHexRgb
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.JsonPrimitive
import kotlinx.serialization.json.buildJsonObject
import org.maplibre.compose.sources.GeoJsonData
import org.maplibre.spatialk.geojson.Feature
import org.maplibre.spatialk.geojson.FeatureCollection
import org.maplibre.spatialk.geojson.Point


data class LabelDrag(val labelId: String, val point: Point)

fun DocumentObject?.labelSelectionGeoJson(drag: LabelDrag? = null): GeoJsonData = GeoJsonData.Features(
    FeatureCollection(
        if (this is Label) {
            listOf(labelFeature(this, drag))
        } else {
            emptyList()
        }
    )
)

fun Document.labelsGeoJson(drag: LabelDrag? = null): GeoJsonData = GeoJsonData.Features(
    FeatureCollection(labels.map { label -> labelFeature(label, drag) })
)

private fun labelFeature(label: Label, drag: LabelDrag?): Feature<Point, JsonObject> = Feature(
    geometry = if (drag?.labelId == label.id) drag.point else label.point,
    properties = buildJsonObject {
        put(MapKeys.MAPITAN_ID_PROPERTY, JsonPrimitive(label.id))
        put(MapKeys.COLOR_PROPERTY, JsonPrimitive(label.color.toHexRgb()))
        put(MapKeys.TEXT_PROPERTY, JsonPrimitive(label.displayText))
    },
)
